module.exports = __webpack_public_path__ + "img/intro_sub_uk.fe567af9.svg";